import { set } from "@/utils/vuex";

export default {
  setAGGridActionMenu: set("aGGridActionMenu"),
  setSelectedRowData: set("selectedRowData"),

  setGridData: set("gridData"),
  setGridDataLoading: set("gridDataLoading"),
};
